import React from 'react';
import { INPUT_METHOD, VIEW_METHOD } from '@atlaskit/editor-common/analytics';
import { ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { commentMessages as messages } from '@atlaskit/editor-common/media';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import { CommentWithDotIcon } from './assets/commentWithDotIcon';
import { getSelectedMediaSingle } from './utils';
export var commentButton = function commentButton(intl, state, api) {
  var _getSelectedMediaSing, _api$annotation;
  var selectMediaNode = (_getSelectedMediaSing = getSelectedMediaSingle(state)) === null || _getSelectedMediaSing === void 0 ? void 0 : _getSelectedMediaSing.node.firstChild;
  var hasActiveComments = false;
  var annotations = api === null || api === void 0 || (_api$annotation = api.annotation) === null || _api$annotation === void 0 || (_api$annotation = _api$annotation.sharedState.currentState()) === null || _api$annotation === void 0 ? void 0 : _api$annotation.annotations;
  if (selectMediaNode && annotations) {
    hasActiveComments = selectMediaNode.marks.some(function (mark) {
      return mark.type.name === 'annotation' && !annotations[mark.attrs.id];
    });
  }
  var title = intl.formatMessage(hasActiveComments ? messages.viewCommentsOnMedia : messages.addCommentOnMedia);
  var onClickHandler = function onClickHandler(state, dispatch) {
    if (api !== null && api !== void 0 && api.annotation && selectMediaNode) {
      var _api$annotation$actio = api.annotation.actions,
        showCommentForBlockNode = _api$annotation$actio.showCommentForBlockNode,
        setInlineCommentDraftState = _api$annotation$actio.setInlineCommentDraftState;
      if (!showCommentForBlockNode(selectMediaNode, VIEW_METHOD.COMMENT_BUTTON)(state, dispatch)) {
        var _selectMediaNode$attr;
        setInlineCommentDraftState(true,
        // TODO: might need to update to reflect it's from media floating toolbar
        INPUT_METHOD.FLOATING_TB, 'block', true, (_selectMediaNode$attr = selectMediaNode.attrs) === null || _selectMediaNode$attr === void 0 ? void 0 : _selectMediaNode$attr.id)(state, dispatch);
      }
    }
    return true;
  };
  return {
    type: 'button',
    testId: 'add-comment-media-button',
    icon: hasActiveComments ? CommentWithDotIcon : CommentIcon,
    title: title,
    onClick: onClickHandler,
    tooltipContent: /*#__PURE__*/React.createElement(ToolTipContent, {
      description: title
    }),
    supportsViewMode: true
  };
};